import rightImg from "images/sectionhero.png";
import rightImg1 from "images/setupapart.png";
import React, { FC } from "react";
import SectionFounder from "./SectionFounder";
import SectionStatistic from "./SectionStatistic";
import { Helmet } from "react-helmet";
import SectionSubscribe2 from "components/SectionSubscribe2/SectionSubscribe2";
import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import BackgroundSection from "components/BackgroundSection/BackgroundSection";
import SectionHero from "./SectionHero";
import SectionClientSay from "components/SectionClientSay/SectionClientSay";
import { globalJson } from "global/global_json";
import SectionHero2 from "./SectionHero2";
import AboutUsSection from "./AboutUsSection";
import SectionInfoBanner from "./SectionInfoBanner";
import WhyChooseUs from "components/WhyChooseUS/WhyChooseUs";
import WhatSetsUsApart from "components/SetupApart/SetupApart";

export interface PageAboutProps {
  className?: string;
}

const PageAbout: FC<PageAboutProps> = ({ className = "" }) => {
  return (
    <div
      className={`nc-PageAbout overflow-hidden relative ${className}`}
      data-nc-id="PageAbout"
    >
      <Helmet>
        <title>About || Car rental</title>
      </Helmet>

      <div className="container py-16 lg:py-28 space-y-16 ">
        <SectionHero
          rightImg={rightImg}
          heading="Your Journey Starts with LA Exotic Autos"
          btnText=""
          subHeading={globalJson?.about_us_para}
        />
      </div>
      <div className="container py-16">
        <div className="bg-[#F5F5F7] rounded-xl">
          <div className="relative py-16">
            <SectionClientSay uniqueClassName="PageAbout_" />
          </div>
        </div>
      </div>
      <div className="container py-16 lg:py-28 space-y-16 ">
        <WhyChooseUs />
      </div>
    </div>
  );
};

export default PageAbout;
